"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconGithub = Experimental__IconGithub;
exports.IconGithub = IconGithub;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconGithub/index.tsx)
 */
function IconGithub(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8.028 0a8.022 8.022 0 0 0-2.535 15.635c.401.072.545-.177.545-.385v-1.364c-2.238.481-2.711-1.05-2.711-1.05a2.126 2.126 0 0 0-.915-1.204c-.73-.498.057-.49.057-.49a1.684 1.684 0 0 1 1.227.803 1.71 1.71 0 0 0 2.334.666c.036-.408.215-.789.506-1.075-1.717-.169-3.626-.859-3.626-3.931a3.105 3.105 0 0 1 .802-2.15 2.888 2.888 0 0 1 .08-2.126s.674-.216 2.206.802a7.605 7.605 0 0 1 4.011 0c1.532-1.035 2.206-.802 2.206-.802a2.88 2.88 0 0 1 .08 2.126 3.1 3.1 0 0 1 .803 2.15c0 3.08-1.877 3.762-3.666 3.955a1.918 1.918 0 0 1 .545 1.484v2.198c0 .256.145.465.554.385A8.022 8.022 0 0 0 8.028 0z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M12.013 2.037A10.002 10.002 0 0 0 8.85 21.532c.498.092.682-.22.682-.485v-1.7c-2.782.613-3.371-1.34-3.371-1.34A2.677 2.677 0 0 0 5.05 16.54c-.903-.614.073-.614.073-.614a2.105 2.105 0 0 1 1.53 1.032 2.137 2.137 0 0 0 2.91.835c.038-.505.256-.98.614-1.339-2.223-.252-4.556-1.111-4.556-4.943a3.868 3.868 0 0 1 1.025-2.683 3.641 3.641 0 0 1 .098-2.646s.842-.27 2.751 1.025c1.64-.45 3.37-.45 5.01 0 1.91-1.296 2.745-1.025 2.745-1.025.368.837.405 1.782.105 2.646.673.73 1.04 1.69 1.025 2.683 0 3.844-2.34 4.685-4.568 4.913a2.365 2.365 0 0 1 .681 1.842v2.744c0 .326.178.577.688.485A10.009 10.009 0 0 0 12.013 2v.037z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconGithub is deprecated and will be archived soon. Use IconGithub instead.
 */
function Experimental__IconGithub(props) {
  return /*#__PURE__*/_react["default"].createElement(IconGithub, props);
}